import React, { useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import EmailUser from "./EmailUser";
import MobileUser from "./MobileUser";
import TitleBar from "../../partials/content/TitleBar";
import AllSiteUserAdvertiser from "./AllSiteUserAdvertiser";
import ButtonDisable from "../../partials/other/ButtonDisable";
import userExample from "../user/UserExample";
import CategorySitePublisherTopic from "../publisher/CategorySitePublisherTopic";

const typeUserString = {
  REAL: 1,
  LEGAL: 2,
};

export default function InfoUser() {
  const initObjectInfoUser = {
    firstname: userExample.firstName,
    lastname: userExample.lastName,
    category_id: userExample.categoryID,
    phone: "02123456789",

    national_code: "1234567890",
    identity_number: "1234567890",

    identity_national: "",
    economic_number: "",
    register_number: "",

    state: "تهران",
    city: "تهران",
    town: "تهران",
    postal_code: "1234567890",
    description: "",
    reason_ban: "",
    email: userExample.email,
    mobile: userExample.firstName,
  };
  const [userInfo, setUserInfo] = useState(initObjectInfoUser);
  const [typeUser, setTypeUser] = useState(typeUserString.REAL);

  const generateCategorySitePublisherTopic = () => {
    return CategorySitePublisherTopic.map((category) => {
      return (
        <option selected={category.id == userInfo.category_id && "selected"}>
          {category.title}
        </option>
      );
    });
  };

  return (
    <>
      <Sidebar activeItem="fill-info-user" />

      <div className="content-wrapper">
        <div className="container-fluid p-0">
          <div className="row m-0">
            <div className="position-relative w-100 title-page-container">
              <div
                className="position-absolute border border-1 border-dark py-2 px-3 title-page"
                style={{ left: "25%" }}
              >
                تایید شماره همراه
              </div>
              <div
                className="position-absolute border border-1 border-dark py-2 px-3 title-page"
                style={{ left: "75%" }}
              >
                تایید ایمیل
              </div>
              <div className="hr-title-page"></div>
            </div>
          </div>
        </div>

        <div className="container-fluid pt-5">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <EmailUser email={userInfo.email} />
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <MobileUser mobile={userInfo.mobile} />
            </div>
          </div>
        </div>

        <AllSiteUserAdvertiser />

        <div className="container-fluid pt-3">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-lg-12 p-0">
              <TitleBar title="اطلاعات کاربری" />

              <section className="content pt-5">
                <div className="card">
                  <div className="card-body" id="fill-info-user">
                    <div className="alert alert-warning ">
                      <p>
                        <i className="fa fa-info pl-2"></i>
                        توجه داشته باشید :{" "}
                      </p>
                      <ul className="pr-3">
                        <li>
                          <p>
                            لطفا توجه داشته باشید که با تغییر اطلاعات شما ,
                            کمپین های قبلی شما به حالت غیر فعال میرود و نقش شما
                            به حالت بررسی نشده تبدیل میشود تا توسط تیم هایلات
                            اطلاعات شما تایید شود.
                          </p>
                        </li>
                      </ul>
                    </div>

                    <form className="d-flex flex-column">
                      <div className="form-group ">
                        <label>نوع کاربر</label>
                        <span class="text-danger">*</span>
                      </div>
                      <div className="d-flex flex-column flex-md-row">
                        <div className="form-group d-flex">
                          <div className="form-check pl-2 ">
                            <input
                              className="form-check-input hover"
                              type="radio"
                              name="type-user"
                              id="real-person"
                              checked={typeUser === typeUserString.REAL}
                              onChange={(e) => {
                                setTypeUser(typeUserString.REAL);
                              }}
                            />
                            <label
                              className="form-check-label hover"
                              for="real-person"
                            >
                              شخص حقیقی
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input hover"
                              type="radio"
                              name="type-user"
                              id="legal-person"
                              checked={typeUser === typeUserString.LEGAL}
                              onChange={(e) => {
                                setTypeUser(typeUserString.LEGAL);
                              }}
                            />
                            <label
                              className="form-check-label hover"
                              for="legal-person"
                            >
                              شخص حقوقی
                            </label>
                          </div>
                        </div>
                      </div>
                      <div>
                        <hr />
                      </div>
                      <div className="d-flex flex-column flex-md-row">
                        {typeUser == typeUserString.REAL ? (
                          <>
                            {" "}
                            <div className="form-group ">
                              <label>
                                نام
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="firstname"
                                placeholder="نام"
                                defaultValue={userInfo.firstname}
                                required
                              />
                            </div>
                            <div className="form-group">
                              <label>نام خانوادگی</label>
                              <span className="text-danger">*</span>
                              <input
                                type="text"
                                className="form-control"
                                id="lastname"
                                placeholder="نام خانوادگی"
                                required
                                defaultValue={userInfo.lastname}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="form-group">
                              <label>نام شخص حقوقی</label>
                              <span className="text-danger">*</span>
                              <input
                                type="text"
                                className="form-control"
                                id="firstname"
                                placeholder="نام شخص حقوقی"
                                required
                                defaultValue={userInfo.firstname}
                              />
                            </div>
                          </>
                        )}

                        <div className="form-group ">
                          <label>دسته صنفی</label>
                          <span className="text-danger">*</span>
                          <select className="form-control" id="cat-guild">
                            <option>انتخاب کنید</option>
                            {generateCategorySitePublisherTopic()}
                            {/* <option>ابزارآلات</option>
                            <option>یراق آلات ساختمانی</option>
                            <option>یراق آلات چوب و دکوراسیون</option>
                            <option>چسب و روان کننده ها</option>
                            <option>ماشین آلات صنعتی و راه سازی</option>
                            <option>پیچ و مهره و اتصالات</option>
                            <option>تجهیزات الکتریکی</option>
                            <option>عمومی</option>
                            <option>درب اتوماتیک</option>
                            <option>رسانه</option>
                            <option>ادوات نصب</option>
                            <option selected={true}>ورزش و سلامتی</option> */}
                          </select>
                        </div>
                      </div>
                      <div>
                        <hr />
                      </div>
                      {typeUser == typeUserString.REAL ? (
                        <>
                          <div className="d-flex flex-column flex-md-row">
                            <div className="form-group">
                              <label>شماره تلفن ثابت</label>
                              <input
                                type="number"
                                className="form-control"
                                id="phone"
                                placeholder="شماره تلفن ثابت"
                                defaultValue={userInfo.phone}
                              />
                            </div>

                            <div className="form-group">
                              <label>کد ملی</label>
                              <input
                                type="number"
                                className="form-control"
                                id="national-code"
                                placeholder="کد ملی"
                                defaultValue={userInfo.national_code}
                              />
                            </div>

                            <div className="form-group">
                              <label>شماره شناسنامه</label>
                              <input
                                type="number"
                                className="form-control"
                                id="identity-number"
                                placeholder="شماره شناسنامه"
                                defaultValue={userInfo.identity_number}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      {typeUser == typeUserString.LEGAL ? (
                        <>
                          <div className="d-flex flex-column flex-md-row">
                            <div className="form-group">
                              <label>شماره تلفن ثابت</label>
                              <input
                                type="number"
                                className="form-control"
                                id="phone"
                                placeholder="شماره تلفن ثابت"
                                defaultValue={userInfo.phone}
                              />
                            </div>
                            <div className="form-group">
                              <label>شناسه ملی</label>
                              <input
                                type="number"
                                className="form-control"
                                id="identity-national"
                                placeholder="شناسه ملی"
                                defaultValue={userInfo.identity_national}
                              />
                            </div>

                            <div className="form-group">
                              <label>شماره اقتصادی</label>
                              <input
                                type="number"
                                className="form-control"
                                id="economic-number"
                                placeholder="شماره اقتصادی"
                                defaultValue={userInfo.economic_number}
                              />
                            </div>

                            <div className="form-group">
                              <label>شماره ثبت</label>
                              <input
                                type="number"
                                className="form-control"
                                id="register-number"
                                placeholder="شماره ثبت"
                                defaultValue={userInfo.register_number}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      <div className="d-flex flex-column flex-md-row">
                        <div className="form-group">
                          <label>استان</label>
                          <input
                            type="text"
                            id="state"
                            className="form-control"
                            placeholder="استان"
                            defaultValue={userInfo.state}
                          />
                        </div>
                        <div className="form-group">
                          <label>شهر</label>
                          <input
                            type="text"
                            id="city"
                            className="form-control"
                            placeholder="شهر"
                            defaultValue={userInfo.city}
                          />
                        </div>
                        <div className="form-group">
                          <label>شهرستان </label>
                          <input
                            type="text"
                            id="town"
                            className="form-control"
                            placeholder="شهرستان "
                            defaultValue={userInfo.town}
                          />
                        </div>

                        <div className="form-group">
                          <label>کد پستی 10 رقمی </label>
                          <input
                            type="number"
                            id="postal-code"
                            className="form-control"
                            placeholder="کد پستی "
                            defaultValue={userInfo.postal_code}
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-column flex-md-row">
                        <div className="form-group description-user-input">
                          <label>آدرس دقیق</label>
                          <input
                            type="text"
                            id="address"
                            className="form-control"
                            placeholder="آدرس"
                            defaultValue={userInfo.address}
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-column flex-md-row">
                        <div className="form-group description-user-input">
                          <label>توضیحات</label>
                          <textarea
                            type="text"
                            id="description"
                            className="form-control"
                            placeholder="توضیحات"
                            rows="8"
                            defaultValue={
                              userInfo.description ? userInfo.description : ""
                            }
                          ></textarea>
                        </div>
                      </div>
                      <div className="d-flex flex-column flex-md-row">
                        <div className="text-center w-100">
                          <ButtonDisable
                            buttonTagHtml={
                              <span className="btn btn-success opacity-50 ">
                                ارسال اطلاعات
                              </span>
                            }
                          ></ButtonDisable>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
